import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import {
  Container,
} from './HybridMailStyles';
import { HybridMailProvider } from './HybridMailContext';
import SidebarContent from './components/SidebarContent';
import PDFPreviewArea from './components/PDFPreviewArea';
import SchedulingModal from './components/SchedulingModal';

export default function HybridMail(props) {
  const { visible, hybridInfo, setCurrentPage, setFilterValues, setFilters, setRequiresMyApproval } = props;


  if (!visible) return null;

  return (
    <HybridMailProvider {...props} handleCurrentPage={setCurrentPage}>
      <DndProvider backend={HTML5Backend}>
        <Container>
          <SidebarContent hybridInfo={hybridInfo}/>
          <PDFPreviewArea 
            setCurrentPage={setCurrentPage}  
            setFilterValues={setFilterValues}
            setFilters={setFilters}
            setRequiresMyApproval={setRequiresMyApproval}/>
        </Container>
        <SchedulingModal/>
      </DndProvider>
    </HybridMailProvider>
  );
}

